import session from './session'
import {ENDPOINT} from './index'

export default {
  filter_call_center (filterData, page, pageSize) {
    return session.post(ENDPOINT + '/callcenter/filter_callcenter/', {page: page, page_size: pageSize, filter: filterData})
  },
  disable_callcenter (data) {
    return session.post(ENDPOINT + '/callcenter/disable_callcenter/', data)
  },
  enable_callcenter (data) {
    return session.post(ENDPOINT + '/callcenter/enable_callcenter/', data)
  },
  create_callcenter (data) {
    return session.post(ENDPOINT + '/callcenter/create_callcenter/', data)
  },
  update_callcenter (data) {
    return session.post(ENDPOINT + '/callcenter/update_callcenter/', data)
  },
  updateStatus (enable, company_id) {
    return enable ? this.enable_callcenter({company_id: company_id}) : this.disable_callcenter({company_id: company_id})
  },
  end_callin (data) {
    return session.post(ENDPOINT + '/callcenter/end_callin/', data)
  },
  end_callout (data) {
    return session.post(ENDPOINT + '/callcenter/end_callout/', data)
  },
  start_callin (data) {
    return session.post(ENDPOINT + '/callcenter/start_callin/', data)
  },
  start_callout (data) {
    return session.post(ENDPOINT + '/callcenter/start_callout/', data)
  },
  get_agents (data) {
    return session.post(ENDPOINT + '/callcenter/get_agents/', data)
  },
  update_agents (data) {
    return session.post(ENDPOINT + '/callcenter/update_agents/', {data: [data]})
  },
  get_company_call_history (data, page = 0, page_size = 10) {
    if (data.number == null || data.number === '') {
      delete data['number']
    }
    if (data.user_id == null || data.user_id === '') {
      delete data['user_id']
    }
    return session.post(ENDPOINT + '/callcenter/get_company_call_history/', {filter: data, page: page, page_size: page_size})
  },
  get_call_report (data, page = 0, page_size = 10) {
    return session.post(ENDPOINT + '/callcenter/get_call_report/', {filter: data, page: page, page_size: page_size})
  },
  get_external_report (data, page = 0, page_size = 10) {
    return session.post(ENDPOINT + '/callcenter/get_external_report/', {report_type: data.report_type, provider: data.provider, page: page, page_size: page_size})
  },
  get_credit_payment_report (data) {
    return session.post(ENDPOINT + '/callcenter/get_credit_payment_report/', data)
  },
  get_callcenter (data) {
    return session.post(ENDPOINT + '/callcenter/get_callcenter/', data)
  },
  get_user_call_history (page = 0, page_size = 10, phone_number = '') {
    return session.post(ENDPOINT + '/callcenter/get_user_call_history/', {page: page, page_size: page_size, phone_number: phone_number})
  },
  export_call_logs (data) {
    return session.post(ENDPOINT + '/callcenter/export_call_logs/', data)
  },

  /**
   * API FOR AGENTS
   */
  create_agent_register (data) {
    return session.post(ENDPOINT + '/callcenter/create_agent_register/', data)
  },

  delete_agent_register (data) {
    return session.post(ENDPOINT + '/callcenter/delete_agent_register/', data)
  },

  filter_agent_register (data, page = 0, pageSize = 10) {
    return session.post(ENDPOINT + '/callcenter/filter_agent_register/', {
      page: page,
      page_size: pageSize,
      filter: data
    })
  },
  uploadExtFile (extFormData) {
    return session.post(ENDPOINT + '/callcenter/upload_ext_file/', extFormData)
  },
  downloadExtFile (company_id) {
    return session.post(ENDPOINT + '/callcenter/download_ext_file/', {company_id: company_id}, {responseType: 'blob'})
  },
  calculatePayment () {
    return session.post(ENDPOINT + '/callcenter/calculate_payment/')
  }
}



// WEBPACK FOOTER //
// ./src/api/callCenter.js